import { Skeleton } from "antd";
import SectionCardSkeleton from "./SectionCardSkeleton";

const PaymentSummarySkeleton = () => (
    <SectionCardSkeleton>
        <div className="mb-4 flex items-center justify-between gap-3">
            <Skeleton.Input active size="small" className="!w-24" />
            <Skeleton.Button active size="small" className="!w-24 !rounded-full" />
        </div>
        <div className="mb-4 grid gap-3 sm:grid-cols-2">
            <Skeleton.Node active className="!h-[88px] !w-full !rounded-xl" style={{ width: "100%" }} />
            <Skeleton.Node active className="!h-[88px] !w-full !rounded-xl" style={{ width: "100%" }} />
        </div>
        <Skeleton.Node active className="!mb-4 !h-[180px] !w-full !rounded-xl" style={{ width: "100%" }} />
        <div className="flex flex-wrap gap-2">
            <Skeleton.Button active className="!w-32" />
            <Skeleton.Button active className="!w-24" />
        </div>
    </SectionCardSkeleton>
);

export default PaymentSummarySkeleton;
